import {Component, Input, OnInit} from '@angular/core';
import {ApiService} from '../api.service';


function insertAtCaret(el, myValue) {
    if (document['selection']) {
        // For browsers like Internet Explorer
        el.focus();
        const sel = document['selection'].createRange();
        // TODO: make adjustments for IE
        sel.text = myValue;
        el.focus();
    } else if (el.selectionStart || el.selectionStart === '0') {
        //For browsers like Firefox and Webkit based
        var startPos = el.selectionStart;
        const endPos = el.selectionEnd;
        const scrollTop = el.scrollTop;
        const lastComma = el.value.substr(0, startPos).lastIndexOf(',');
        const lastBreak = el.value.substr(0, startPos).lastIndexOf('\n');
        startPos = lastComma;
        if (lastBreak > lastComma) {
            startPos = lastBreak;
        }
        startPos++;

        el.value = el.value.substring(0, startPos) + myValue + el.value.substring(endPos, el.value.length);
        el.focus();
        el.selectionStart = startPos + myValue.length;
        el.selectionEnd = startPos + myValue.length;
        el.scrollTop = scrollTop;
    } else {
        el.value += myValue;
        el.focus();
    }
}

@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.css']
})
export class TagsComponent implements OnInit {
    @Input() module: string;
    public tags: string[];
    public availableTags;
    public autocompletion: string[];
    public newtags: string;
    public selectedAutocomplete = 0;
    public showAutocomplete = false;

    constructor(protected apiService: ApiService) {
        this.tags = [];
    }

    getTags() {
        if (!this.module) {
            return;
        }
        this.apiService.getTags(this.module).subscribe((value) => {
            this.availableTags = value;
            this.availableTags.sort((a, b) => {
                return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
            });
        });
    }

// todo: add autocomplete as the user types
    ngOnInit() {
        this.getTags();
    }

    autocomplete(e) {
        if (e.key === 'Tab' && this.autocompletion.length > 0) {
            insertAtCaret(e.target, this.autocompletion[this.selectedAutocomplete]);
            this.newtags = e.target.value;
            return false;
        }
    }

    public getAutocompletion(event) {
        if (!this.availableTags) {
            this.autocompletion = [];
            return;
        }
        if (event.key === 'Escape') {
            this.showAutocomplete = false;
            return;
        }
        if (event.key === 'ArrowDown' && this.selectedAutocomplete + 1 < this.autocompletion.length) {
            this.selectedAutocomplete++;
        }
        if (event.key === 'ArrowUp' && this.selectedAutocomplete > 0) {
            this.selectedAutocomplete--;
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            return;
        }
        this.showAutocomplete = true;
        const value = event.target.value;
        const cursorPos = event.target.selectionStart;
        const textTillCursor = value.substr(0, cursorPos);
        const enteredTags = value.split(',').map((tag) => tag.trim());
        let lastComma = value.lastIndexOf(',');
        if (lastComma < 0) {
            lastComma = 0;
        } else {
            lastComma++;
        }
        const currentText = textTillCursor.substr(lastComma).trim();
        this.autocompletion = this.availableTags.filter((tag) => {
            return tag.substr(0, currentText.length) === currentText && enteredTags.indexOf(tag) === -1 && this.tags.indexOf(tag) === -1;
        });
        if (this.selectedAutocomplete >= this.autocompletion.length) {
            this.selectedAutocomplete = this.autocompletion.length - 1;
        }
        if (this.selectedAutocomplete < 0) {
            this.selectedAutocomplete = 0;
        }
    }

    public addTags() {
        const tags = this.newtags.split(',').map((val) => val.trim()).filter((tag) => tag.trim() !== "");
        this.tags = this.tags.concat(tags).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
        this.newtags = '';
    }

    public removeTag(tag) {
        this.tags = this.tags.filter((val) => {
            const isTagToRemove = tag !== val;
            return isTagToRemove;
        });
    }

    public hideAutocompletion(event) {
        const originalTarget = event.explicitOriginalTarget;
        const target = event.target;
        const inputField = <HTMLInputElement>document.getElementById('newtag');
        let tag = false;
		// Tag suggestion got clicked from autocomplete
        if (originalTarget.classList && originalTarget.classList.contains('autocomplete-suggestion')) {
            tag = originalTarget.innerText;
		// Tag suggestion got clicked from autocomplete but text node got the event
        } else if (originalTarget.parentElement.classList && originalTarget.parentElement.classList.contains('autocomplete-suggestion')) { 
			tag = originalTarget.parentElement.innerText;
		// Tag suggestion got clicked and is the actual target
		} else if (target.classList && target.classList.contains('autocomplete-suggestion')) {
            tag = target.innerText;
        }
        if (tag) {
            insertAtCaret(inputField, tag + ', ');
            this.newtags = inputField.value;
            inputField.focus();
            inputField.selectionStart = inputField.selectionEnd = inputField.innerText.length;
            const enteredTags = inputField.value.split(',').map((theTag) => theTag.trim());
            this.autocompletion = this.availableTags.filter((availableTag) => {
                return enteredTags.indexOf(availableTag) === -1 && this.tags.indexOf(availableTag) === -1;
            });
        }
        this.showAutocomplete = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/tags/tags.component.ts